import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckTick = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 13,
	viewBox: "0 0 17 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5 6.5L6.01684 11.7247L6.41768 11.0238C8.56681 7.26584 11.541 4.0448 15.1161 1.60354L16 1",
		stroke: "#71717A",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCheckTick);
export default ForwardRef;
